import ReactLoading from "react-loading";
import Image from "next/image";

import addPhotoIcon from "@/assets/icons/photoRegister/add_photo.svg";

type Props = {
  isUpLoading: boolean;
  handleAddUploader: () => void;
};

/* さらに追加UI */
const AddUploader: React.FC<Props> = ({ isUpLoading, handleAddUploader }) => {
  return (
    <div
      className={`relative flex min-h-[7.5rem] min-w-[10rem] cursor-pointer flex-col items-center justify-center gap-4 rounded-sm bg-cdisabled active:scale-[.98] ${
        isUpLoading ? "cursor-wait" : "cursor-pointer"
      }`}
      onClick={() => {
        if (!isUpLoading) handleAddUploader();
      }}
    >
      <Image src={addPhotoIcon} alt="add_photo" width={26} height={24} />
      <div className="text-sm font-medium text-white">さらに追加</div>
      {isUpLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/60">
          <ReactLoading color="#fff" width="3rem" height="3rem" type="spin" />
        </div>
      )}
    </div>
  );
};

export default AddUploader;
